<template>

  <div class="row  productPrice200">
    <div class="col-12">

      <div class="" v-if="product.price !== null && product.variation ==0">

        <div class="product-price fa-num">
          <div class="" v-if="initOffer() > 0">
            <span class="">
            <del class="price-old text-danger"
                 v-html="$t('price.price', {currency: formatNumber(product.price )})"></del>
            </span>
            <span class="product-price-200-offer-percent  mr-2">{{ initOffer() }}%</span>
          </div>
          <span class="price-now "
                v-html="$t('price.price', {currency: formatNumber(product.price - product.offer)})">
          </span>
        </div>

      </div>

      <div class="" v-if="product.variation ==1">
        <span class="product-price" v-if="productOfferChecker(product)"
              v-html="$t('price.offer', {currency: productOfferRange})">
        </span>
        <div class="product-price fa-num">
          <span class="price-now" v-html="$t('price.price', {currency: productPriceRange})"></span>
        </div>
      </div>

      <div class="" v-if="product.variation ==2">
        <div class="product-price fa-num">
          <span class="price-now" v-html="$t('price.price', {currency: formatNumber(product.min_price)})"></span>
        </div>
      </div>

      <div class="" v-if="checkProductHaveFormula(product)">


        <div class="product-price fa-num" v-if="product.offer>0">
          <div class="">
            <del class="price-old" v-html="$t('price.price', {currency: formatNumber(product.min_price )})"></del>
          </div>
          <span class="price-now"
                v-html="$t('price.price', {currency: formatNumber(product.min_price - product.offer)})">
          </span>
        </div>
        <div class="product-price fa-num" v-else>
          <span class="price-now" v-html="$t('price.price', {currency: formatNumber(product.min_price)})"></span>
        </div>
      </div>

      <div class="" v-if="checkProductHaveSubscription(product)">




        <div class="product-price fa-num" v-if="productSubscriptionPriceCalculator(product)['offer']>0">
          <div class="">
            <del class="price-old" v-html="$t('price.price', {currency: formatNumber(productSubscriptionPriceCalculator(product)['price'] )})"></del>
          </div>
          <span class="price-now"
                v-html="$t('price.price', {currency: formatNumber(productSubscriptionPriceCalculator(product)['price'] - productSubscriptionPriceCalculator(product)['offer'])})">
          </span>
        </div>
        <div class="product-price fa-num" v-else>
          <span class="price-now" v-html="$t('price.price', {currency: formatNumber(productSubscriptionPriceCalculator(product)['price'])})"></span>
        </div>
      </div>


    </div>
  </div>


</template>

<script>
import {formatNumber, flatten} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  getProductPriceRange,
  getProductOfferRange,
  productOfferChecker
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {checkProductHaveFormula} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

const checkProductHaveSubscription = (product) => {
  return product.subscriptions != null && Object.keys(product.subscriptions).length > 0
}

const productSubscriptionPriceCalculator = (product) => {
  let subscriptions = product.subscriptions
  let result = {
    offer: 0,
    price: 0,
  }
  subscriptions.forEach(item => {
    result["offer"] += item.subscription_item.offer
    result["price"] += item.subscription_item.price
  })

  return result

}

export default {
  name: "price",
  props: {
    product: {}
  },
  data() {
    return {
      offer: 0,
      price: 0,
      offerPercentValue: 0,
    }
  },
  computed: {
    productPriceRange() {
      return this.getProductPriceRange(this.product)
    },
    productOfferRange() {
      return this.getProductOfferRange(this.product)
    }
  },
  methods: {
    checkProductHaveSubscription,
    productSubscriptionPriceCalculator,
    checkProductHaveFormula,
    formatNumber,
    getProductPriceRange,
    getProductOfferRange,
    productOfferChecker,
    flatten,
    productOfferWrapper() {
      const variation = this.product.variation
      if (variation == 1) {
        const price = this.getProductOfferRange(this.product, 'object')['max'];
        return parseInt(price)
      }
      return this.product.offer
    },
    productPriceWrapper() {
      const variation = this.product.variation
      if (variation == 1) {
        return this.getProductPriceRange(this.product, 'object')['max']
      }
      return this.product.price
    },
    offerPercent(price, offer) {
      return Math.round((offer * 100) / price)
    },
    initOffer() {
      let offer = this.productOfferWrapper(this.product)
      let price = this.productPriceWrapper(this.product)
      return this.offerPercent(price, offer)
    }
  },
  updated() {
    this.initOffer()
  },
  mounted() {
    this.initOffer()
  },

}
</script>

<style scoped>
.productPrice200 * {
  font-size: 13px;
  -webkit-line-clamp: 2;
}

.product-price {
  font-size: 15px;
  font-weight: bold !important;
  color: var(--dark) !important;
}

.product-price .price-old {
  color: gray;
}

.product-card.product-card-horizontal .product-card-body .product-price {
  margin-top: 20px;
}

.product-price-200-offer-percent {
  padding: 2px 7px;
  font-size: 11px;
  border-radius: 40px;
  color: white;
  background: var(--danger);
}


</style>